// extracted by mini-css-extract-plugin
export default {"logoWrapper":"AppBar_logoWrapper__M3LhU","societyImage":"AppBar_societyImage__prGPj","cartCounter":"AppBar_cartCounter__zjAp1"};